// @ts-ignore
/* eslint-disable */
import { EncryptAes } from '@/utils/Crypto';
import { request } from '@umijs/max';

/** 获取当前的用户 GET /api/v1/system/users/me */
export async function currentUser(options?: { [key: string]: any }) {
  try {
    const response = await request<API.LoginResult>('/api/v1/system/users/me', {
      method: 'GET',
      ...(options || {}),
    });
    // 处理瀚泽互联网云平台的API响应格式
    if (response.code == 200) {
      return response;
    } else {
      throw new Error(response.message || '获取用户信息失败');
    }
  } catch (error: any) {
    throw error;
  }
}

/** 退出登录接口 POST /api/v1/system/users/logout */
export async function outLogin(options?: { [key: string]: any }) {

  // 清除本地存储的token
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('refresh_token');
  // try {
  //   console.log('调用outLogin API，URL:', '/api/v1/system/users/logout');
  //   const response = await request<Record<string, any>>('/api/v1/system/users/logout', {
  //     method: 'POST',
  //     ...(options || {}),
  //   });

  //   // 清除本地存储的token
  //   localStorage.removeItem('refreshToken');
  //   localStorage.removeItem('refresh_token');

  //   return response;
  // } catch (error) {
  //   console.error('退出登录失败:', error);
  //   // 即使API调用失败，也要清除本地token
  //   localStorage.removeItem('refreshToken');
  //   localStorage.removeItem('refresh_token');
  //   throw error;
  // }
}

/** 登录接口 POST /system/p/login */
export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  try {
    console.log('调用login API，URL:', '/system/p/login', '数据:', body);

    // 构造Java后端需要的请求格式
    const javaRequestBody = {
      device: 'swagger',
      username: body.username,
      password: EncryptAes(body.password),
      rememberMe: true,
    };

    const response = await request<API.LoginResult>('/prod-api/system/p/merchants/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: javaRequestBody,
      ...(options || {}),
    });

    // 处理Java后端的响应格式
    if (response.code === 200) {
      // 登录成功，保存token到本地存储
      if (response.data?.accessToken) {
        localStorage.setItem('refreshToken', response.data.accessToken);
      }
      if (response.data?.refreshToken) {
        localStorage.setItem('refresh_token', response.data.refreshToken);
      }

      // 转换为前端期望的格式
      return {
        success: true,
        message: response.message,
        data: response.data,
        code: response.code,
      };
    } else {
      // 登录失败
      return {
        success: false,
        message: response.message || '登录失败',
        data: undefined,
        code: response.code,
      };
    }
  } catch (error) {
    console.error('登录失败:', error);
    throw error;
  }
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any }
) {
  return request<API.RuleList>('/api/rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rule', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}
